module.exports = __webpack_public_path__ + "img/logo-300x53.2db88137.png";